(function ($) {
	$(".testimonial_slider").slick({
		arrows: true,
		infinite: true,
		centerMode: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $('.prev'),
		nextArrow: $('.next')
	})

})(jQuery);

// const handleScroll = () => {

// 	let viewportTop = window.scrollY + window.innerHeight;

// 	let elementTop =
// 		stickyHeaderHome.getBoundingClientRect().top + window.scrollY;
// 	let newElementTop = elementTop + 801;

// 	if (viewportTop >= newElementTop) {
// 		stickyHeaderHome.classList.add("sticky");
// 		console.log("Adding 'sticky' class");
// 	} else if ((viewportTop = newElementTop)) {
// 		stickyHeaderHome.classList.remove("sticky");
// 		console.log("Removing 'sticky' class");
// 	}
// };

// window.addEventListener("scroll", handleScroll);

// // Remove the event listener when not needed (e.g., when the component is unmounted)
// const cleanup = () => {
// 	window.removeEventListener("scroll", handleScroll);
// };

//  let navwrapper = document.querySelector(".navigation_wrap");
let lastScroll = 0;

let stickyHeaderHome = document.querySelector(".sticky-header-home");
window.addEventListener("scroll", () => {
	let currentScrollPos = window.scrollY;

	let currentScroll = window.scrollY;

	if (currentScrollPos >= 750) {
		// Scrolling down
		stickyHeaderHome?.classList.add("sticky");
	} else {
		// Scrolling up
		stickyHeaderHome?.classList.remove("sticky");
	}

	lastScroll = currentScroll;
});
